module.exports = __webpack_public_path__ + "static/media/Bigblue.919e3f03.pdf";